import { render, staticRenderFns } from "./bind-menu.vue?vue&type=template&id=4cad4b0e&scoped=true"
import script from "./bind-menu.vue?vue&type=script&lang=js"
export * from "./bind-menu.vue?vue&type=script&lang=js"
import style0 from "./bind-menu.vue?vue&type=style&index=0&id=4cad4b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cad4b0e",
  null
  
)

export default component.exports